import { render, staticRenderFns } from "./403.vue?vue&type=template&id=6b2aa5ff&scoped=true"
var script = {}
import style0 from "./403.vue?vue&type=style&index=0&id=6b2aa5ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2aa5ff",
  null
  
)

export default component.exports